import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { useT } from '~app/core/BundleProvider';

const docTypeMap = {
  graph: 'graph',
  causal: 'causal',
  conceptual: 'conceptual',
};
// This the hints component
// state changes when actions performed in the canvas area
function StepThroughPanel() {
  const t = useT();
  const doctype = useSelector(state => state.document.present?.type);
  const labelBankExpanded = useSelector(
    state => state.canvas.labelBankExpanded,
  );
  const nodes =
    useSelector(state => state.document.present?.workingModel?.nodes) ?? {};
  const nodesLength = Object.keys(nodes).length;
  const selection = useSelector(state => state.canvas.selection);
  const selectedNode = useSelector(
    state => state.document.present?.workingModel?.nodes?.[selection.label],
    shallowEqual,
  );

  let showHints = useSelector(state => state.canvas?.showHints);
  let hintState = '';

  if (showHints) {
    const arr_nodesValues = Object.values(nodes);
    const arr_flowNodes = arr_nodesValues.filter(n => n.type === 'flow');
    const flowConnections = new Set();
    arr_flowNodes.forEach(item => {
      flowConnections.add(item?.connectFrom);
      flowConnections.add(item?.connectTo);
    });

    // workspace actions

    //No objects in workspace and object bank is closed in a Conceptual Diagram or Stock and Flow Diagram
    if (
      (doctype === 'stockflow' || docTypeMap[doctype]) &&
      !labelBankExpanded &&
      nodesLength === 0
    ) {
      hintState = 'openBank';
    }
    //No objects in workspace and object bank is open in a Conceptual Diagram or Stock and Flow Diagram
    else if (
      (doctype === 'stockflow' || docTypeMap[doctype]) &&
      labelBankExpanded &&
      nodesLength === 0
    ) {
      hintState = 'populateWorkspace';
    }
    //A connector button is selected in the menu in a Stock and Flow Diagram
    else if (
      doctype === 'stockflow' &&
      selection?.latched === true &&
      selection?.latchData.action === 'addSignal'
    ) {
      hintState = 'connectorButtonStockFlowOptions';
    }
    //A connector button is selected in the menu in a Conceptual Diagram
    else if (
      docTypeMap[doctype] &&
      selection?.latched === true &&
      selection?.latchData.action === 'addSignal'
    ) {
      hintState = 'connectorButtonConceptualOptions';
    }
    //An unassigned object is selected.
    else if (
      doctype === 'stockflow' &&
      selection?.type === 'node' &&
      selectedNode?.type === 'unassigned'
    ) {
      hintState = 'assign';
    }
    //An object is selected in a Conceptual Diagram
    else if (docTypeMap[doctype] && selection?.type === 'node') {
      hintState = 'selectedObjectConceptualOptions';
    }
    //A stock not connected to a flow is selected.
    else if (
      doctype === 'stockflow' &&
      selectedNode?.type === 'stock' &&
      !flowConnections.has(selection?.label)
    ) {
      hintState = 'unlinkedStockOptions';
    }
    //A stock connected to a flow is selected.
    else if (
      doctype === 'stockflow' &&
      selectedNode?.type === 'stock' &&
      flowConnections.has(selection?.label)
    ) {
      hintState = 'linkedStockOptions';
    }
    //A variable is selected.
    else if (doctype === 'stockflow' && selectedNode?.type === 'variable') {
      hintState = 'selectedVariableOptions';
    }
    //A flow is selected.
    else if (doctype === 'stockflow' && selectedNode?.type === 'flow') {
      hintState = 'flowOptions';
    }
    //A connector on the workspace is selected.
    else if (doctype === 'stockflow' && selection?.type === 'signal') {
      hintState = 'selectedConnectorOptions';
    }
    //If none of these states in effect, hintState is empty string
    else {
      hintState = '';
    }
  }

  return showHints && hintState ? (
    <div
      className={`StepThroughPanel ${
        labelBankExpanded ? 'StepThroughPanel-openSubPanel' : ''
      }`}
    >
      {/* dangerouslySetInnerHTML is not a concern here because we know our static strings.json is sanitary */}
      <div
        dangerouslySetInnerHTML={{ __html: t(`hintState-${hintState}`) }}
      ></div>
    </div>
  ) : null;
}

export default StepThroughPanel;
